"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Check = function Check(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/check-check" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    fillRule: "nonzero",
    id: "path-15-check" + unique,
    xlinkHref: "#path-1-check" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-check" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.0789523,4.38486641 L21.8651336,5.17104774 C22.0603957,5.36630989 22.0603957,5.68289238 21.8651336,5.87815452 L8.1439753,19.5993128 C7.94871316,19.794575 7.63213067,19.794575 7.43686852,19.5993128 L2.13486641,14.2973107 C1.93960426,14.1020485 1.93960426,13.7854661 2.13486641,13.5902039 L2.92104774,12.8040226 C3.11630989,12.6087604 3.43289238,12.6087604 3.62815452,12.8040226 L7.79042191,16.96629 L20.3718455,4.38486641 C20.5671076,4.18960426 20.8836901,4.18960426 21.0789523,4.38486641 Z",
    fill: "inherit",
    id: "path-1-check" + unique
  }))));
};

Check.propTypes = propTypes;
var _default = Check;
exports["default"] = _default;